import './SignInView.scss';

import { useCallback } from 'react';
import { Route, Switch } from 'react-router-dom';
import Box from 'fe-design-base/atoms/Box';
import {
  useIsLargeScreen,
  useIsMediumScreen,
} from 'fe-design-base/utils/useMediaQuery';

import FlexLayoutReset from 'components/FlexLayoutReset';

import {
  EVENT_ACTIONS,
  EVENT_CATEGORIES,
  PRODUCT_AREAS,
  TRACK_ACTION_TYPES,
} from 'util/tracking_constants';
import { getUrlParamValue } from 'util/urlParams';
import { useTrackUx, withUxRoot } from 'util/uxEvents';

import { FORGOT_PASSWORD_PATH } from './constants';
import ForgotPasswordContainer from './ForgotPassword';
import LeftPanelWrapper from './LeftPanel';
import MfaForm from './MfaForm';
import PhoneVerification from './PhoneVerification';
import SignInContainer from './SignInContainer';

const SignInView = () => {
  const isLarge = useIsLargeScreen();
  const isMedium = useIsMediumScreen();
  const trackUx = useTrackUx();

  const handleErrorTracking = useCallback(
    (errorMessage: string) => {
      trackUx(EVENT_ACTIONS.ERROR_MESSAGE_SHOWN, TRACK_ACTION_TYPES.VIEW, {
        errorMessage,
      });
    },
    [trackUx]
  );

  const handleSuccess = useCallback(() => {
    window.sessionStorage.removeItem('TEMP_EMAIL');
  }, []);

  return (
    <Box
      h={isLarge ? '100%' : 'initial'}
      className="SignInView"
      bgcolor="mono0"
      pb={isLarge ? 0 : 48}
    >
      <FlexLayoutReset />
      <Box row={isLarge} column={!isLarge} h="100%">
        {isLarge && <LeftPanelWrapper />}
        <Box hcenter vcenter grow={1} p={20} mt={isMedium ? 80 : 16}>
          <Switch>
            <Route exact path="/accounts/sign-in">
              <SignInContainer
                onError={handleErrorTracking}
                onSuccess={handleSuccess}
              />
            </Route>
            <Route exact path={FORGOT_PASSWORD_PATH}>
              <ForgotPasswordContainer
                onError={handleErrorTracking}
                onSuccess={handleSuccess}
              />
            </Route>
            <Route exact path="/authentication/mfa">
              <MfaForm
                onError={handleErrorTracking}
                onSuccess={handleSuccess}
              />
            </Route>
            <Route
              exact
              path="/authentication/delegated-verification/validate-code"
            >
              <PhoneVerification onError={handleErrorTracking} />
            </Route>
          </Switch>
        </Box>
      </Box>
    </Box>
  );
};

export default withUxRoot({
  productArea: PRODUCT_AREAS.SIGN_IN,
  eventCategory: EVENT_CATEGORIES.SIGN_IN,
  signUpAttemptedAccountExists: getUrlParamValue('recognized_user') === 'owner',
})(SignInView);
